export enum ROUTES {
  CALCULATE_BY_PRODUCTS_CONTENT = "ExtCalc",
  CALCULATE_MIXES_CONTENT = "Calc",
}

export enum BREAKPOINTS {
  EXTRA_EXTRA_SMALL = 440,
  EXTRA_SMALL = 500,
  SMALL = 640,
  MEDIUM = 720,
  LARGE = 800,
  EXTRA_LARGE = 1140,
  EXTRA_EXTRA_LARGE = 1350,
}

export const PRIVACY_POLICY_COOKIE_KEY = 'hide_privacy_policy_message_calc';
